import styled, { keyframes } from "styled-components";

import { Paper, Grid, Container, Icon, Avatar } from "@material-ui/core";

import ListItemText from "@material-ui/core/ListItemText";

/* -------- Estilização ---------- */

// Cores
const primary = (props) => props.theme.palette.primary;
const secondary = (props) => props.theme.palette.secondary;
const green = (props) => props.theme.palette.green;
const orange = (props) => props.theme.palette.orange;
const red = (props) => props.theme.palette.darkred;
const blue = (props) => props.theme.palette.blue;

const lightgreen = (props) => props.theme.palette.lightgreen;

// Fontes
const montserrat = (props) => props.theme.fonts.montserrat;
const mulish = (props) => props.theme.fonts.mulish;
const opensans = (props) => props.theme.fonts.opensans;

export const Header = styled.div`
  width: 100%;
`;
export const Body = styled.div`
  width: 100%;
`;

export const DataAria = styled.div``;
export const DataTable = styled.div`
  Table {
    Thead {
      background-color: ${secondary};
      box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
      tr {
        .Mui-checked {
          color: ${primary};
        }
        th {
          span {
            font-family: ${montserrat}, sans-serif !important;
          }
        }
      }
    }
    Tbody {
      td {
        font-family: ${montserrat}, sans-serif !important;
        .Mui-checked {
          color: ${primary};
        }
      }
      .Mui-selected {
        background-color: ${lightgreen};
        &:hover {
          background-color: ${lightgreen};
        }
        border: none;
      }
    }
  }
`;
export const MainContent = styled.div``;

export const Form = styled.div`
  .MuiFormControl-root {
    width: 100%;
    display: flex;
    width: 100%;
    label {
      font-family: ${montserrat} !important;
    }

    input {
      font-family: ${montserrat} !important;
    }
  }
`;

export const ImageAria = styled.div``;

export const Finaliza = styled.div``;

export const PedidoContainer = styled(Container)`
  margin-top: 15vh;

  Button {
    span {
      font-family: ${mulish};
      font-weight: bolder;
    }

    min-width: unset;

    .MuiIcon-root {
      font-family: "Material Icons" !important;
    }

    &.Standard {
      max-width: 35px;
      margin: 0 auto;
    }
  }

  ${MainContent} {
    min-height: 40vh;
    display: flex;
    width: 100%;

    ${DataAria} {
      ${ImageAria} {
        min-height: 20vh;
        width: 100%;
        padding: 8px;
      }
    }

    ${DataTable} {
    }
  }

  ${Finaliza} {
    margin-top: 16px;

    Button {
      min-height: 50px;
    }
  }
`;

const ModalOpen = keyframes`
  from {
    transform: translateY(40px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const ModalContent = styled.div`
  padding: 8px;
  animation: ${ModalOpen} 0.8s ease;
`;

export const ReceberContainer = styled.div`
  margin-top: 12vh;

  Button {
    min-width: unset;
  }

  ${MainContent} {
    min-height: 25vh;
    display: flex;
    margin-top: 20px;

    ${DataTable} {
      width: 100%;

      .default-grid,
      .MuiPaper-root {
        height: 100%;
      }
    }

    ${DataAria} {
      width: 100%;
      margin-bottom: 20px;

      .MuiListItem-root {
        max-height: 75px;
      }

      .MuiAvatar-colorDefault {
        background-color: ${primary};
      }

      .MuiListItemText-root {
        span,
        p {
          font-family: ${montserrat} !important;
          font-size: 1em;
        }
      }
    }
  }
`;

export const AvatarCustom = styled(Avatar)`
  height: 50px;
  width: 50px;
  margin-right: 15px;

  &.Green {
    background: ${green} !important;
  }

  &.Orange {
    background: ${orange} !important;
  }

  &.Red {
    background: ${red} !important;
  }

  &.Blue {
    background: ${blue} !important;
  }
`;

export const ModalButtons = styled.div`
  width: 100%;

  Button {
    min-height: 40px;
    span {
      font-family: ${mulish};
      font-weight: bolder;
    }
    min-width: unset;
    .MuiIcon-root {
      font-family: "Material Icons" !important;
    }
  }
`;

export const BtnLine = styled.div`
  margin-left: auto;
  padding: 8px;
`;

export const Separator = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    width: 100%;
    display: block;
    margin-top: 15px;
  }
`;

export const BtnGrid = styled(Grid)`
  :not(.Exception) {
    margin-left: auto !important;
  }

  @media screen and (max-width: 600px) {
    margin-left: auto !important;
  }
`;

export const IconCustom = styled(Icon)`
  font-size: 1rem !important;
`;

export const CustomGrid = styled(Grid)`
  max-width: calc(87.666%) !important;

  @media screen and (max-width: 1260px) {
    max-width: 100% !important;
  }
`;

export const CustomPaper = styled(Paper)`
  padding: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    height: 180px;
    width: 100%;
    object-fit: contain;
  }
`;

export const DiscountSpan = styled.span`
  font-size: 18px;
  font-family: ${opensans};
  margin-bottom: 15px;

  > b {
    font-weight: bold;
  }
`;

export const CustomItemListText = styled(ListItemText)`
  &.greenSecondaryText {
    .MuiListItemText-secondary {
      color: ${green} !important;
    }
  }

  &.redSecondaryText {
    .MuiListItemText-secondary {
      color: ${red} !important;
    }
  }

  &.primaryText {
    .MuiListItemText-secondary {
      color: ${primary} !important;
    }
  }

  &.orangeText {
    .MuiListItemText-secondary {
      color: ${orange} !important;
    }
  }

  &.blueText {
    .MuiListItemText-secondary {
      color: ${blue} !important;
    }
  }

  .MuiListItemText-secondary {
    font-size: 1.2em !important;
    font-weight: bold !important;
  }
`;
